module.exports = __webpack_public_path__ + "static/img/作品22.bfd83d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品22.png
// module id = 8N00
// module chunks = 1